import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Event sent when a user views the onboarding job title step',
  name: 'viewed_onboarding_job_title',
};

export default META;
